import React, { useEffect, useState } from 'react';
import { Form, Image } from 'react-bootstrap';
import StarRating from 'react-star-ratings';
import { useSearchParams, useNavigate } from 'react-router-dom';
import MessageContainer from '../components/Message/MessageContainer';

import ArrowLeftIcon from '../assets/icon/arrowLeft.svg';
import StatusFeedbackBomIcon from '../assets/icon/statusFeedbackBom.svg';
import StatusFeedbackMedioIcon from '../assets/icon/statusFeedbackMedio.svg';
import StatusFeedbackRuimIcon from '../assets/icon/statusFeedbackRuim.svg';
import ChatIcon from '../assets/icon/mensagem.svg';

import api from '../services/apiClient';
import { Message } from '../interfaces/IMessage';
import IFeedbackData from '../interfaces/IFeedbackData';
import { formatLocalDateTime } from '../utils/dateTime';

interface Messages {
  seqAtendimento: number;
  messages: Message[];
}

interface Props {
  dataDetail: IFeedbackData;
  setShowDetail: React.Dispatch<React.SetStateAction<boolean>>;
}

const showIconFeedback = (avaliacao: number): string => {
  if (avaliacao <= 2) return StatusFeedbackRuimIcon;
  if (avaliacao <= 3) return StatusFeedbackMedioIcon;
  return StatusFeedbackBomIcon;
};

const textStatusFeedback = (avaliacao: number): [string, string] => {
  if (avaliacao <= 2) return ['Atendimento', 'Ruim'];
  if (avaliacao <= 3) return ['Atendimento', 'Medio'];
  return ['Bom', 'Atendimento'];
};

const FeedbackDetail: React.FC<any> = ({
  dataDetail,
  setShowDetail,
}: Props) => {
  const [historicoConversa, setHistoricoConversa] = useState<Messages>(
    {} as Messages
  );
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  const filtroId = searchParams.get('id');

  const loadMensagem = (): void => {
    const token = localStorage.getItem('@LiveChat:token');

    api
      .get(`api/AtendimentoMensagem/${dataDetail.seqAtendimento}`, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((response) => {
        const { success } = response.data;

        if (success) {
          const msg: Messages = {
            messages: response.data.data,
            seqAtendimento: dataDetail.seqAtendimento,
          };
          setHistoricoConversa(msg);
        }
      });
  };

  useEffect(() => {
    loadMensagem();
  }, [dataDetail]);

  return (
    <div className="d-flex">
      <section
        className="col-7"
        style={{
          borderRadius: '0.68rem',
          height: 'Calc(100vh - 14.6rem)',
          boxShadow: '0px 4px 6px 3px rgba(0, 0, 0, 0.25)',
        }}
      >
        <div
          className="d-flex align-items-center ps-3"
          style={{
            borderTopLeftRadius: '0.68rem',
            borderTopRightRadius: '0.68rem',
            borderColor: 'transparent',
            backgroundColor: '#1A1A1A',
            fontSize: '1.25rem',
          }}
        >
          <div
            role="button"
            className="d-flex align-items-center"
            tabIndex={0}
            onKeyPress={() => setShowDetail(false)}
            onClick={() => {
              if (filtroId) navigate('/Dashboard');

              setShowDetail(false);
            }}
          >
            <Image
              src={ArrowLeftIcon}
              alt="Mensagens"
              style={{ width: '1.8rem', height: '1.8rem' }}
            />
            <span
              className="text-white ms-2"
              style={{
                fontSize: '1.68rem',
                fontWeight: '600',
              }}
            >
              Voltar
            </span>
          </div>
        </div>
        <div className="d-flex flex-column">
          <div
            className="d-flex align-items-center ms-2 mt-2"
            style={{ flex: '1' }}
          >
            <Image
              src={showIconFeedback(dataDetail.avaliacao)}
              alt="Status atendimento"
              style={{ height: '4.25rem', width: '4.25rem' }}
            />
            <div
              className="d-flex flex-column"
              style={{
                fontSize: '1.6rem',
                fontWeight: '600',
                wordWrap: 'break-word',
              }}
            >
              {textStatusFeedback(dataDetail.avaliacao).map((text) => (
                <span
                  key={text}
                  style={{
                    fontSize: '1.6rem',
                    fontWeight: '600',
                    wordWrap: 'break-word',
                  }}
                >
                  {text}
                </span>
              ))}
            </div>
          </div>
          <div className="d-flex align-items-center ms-4 mt-3">
            <div
              className="d-flex flex-column justify-content-around"
              style={{
                fontSize: '1.25rem',
                fontWeight: '600',
                height: '17rem',
                flex: '1',
              }}
            >
              <div className="d-flex">
                <span style={{ width: '18rem' }}>Nome:</span>
                <span style={{ flex: '1' }}>{dataDetail.nomeCliente}</span>
              </div>
              <div className="d-flex">
                <span style={{ width: '18rem' }}>Departamento:</span>
                <span>{dataDetail.nomeDepartamento}</span>
              </div>
              <div className="d-flex">
                <span style={{ width: '18rem' }}>Operador:</span>
                <span>{dataDetail.atendente}</span>
              </div>
              <div className="d-flex">
                <span style={{ width: '18rem' }}>Data:</span>
                <span>
                  {formatLocalDateTime(
                    dataDetail.dataAtendimentoCriado,
                    'dd/MM/yyyy'
                  )}
                </span>
              </div>
              <div className="d-flex">
                <span className="flex-shrink-0" style={{ width: '18rem' }}>
                  E-mail:
                </span>
                <span
                  style={{
                    wordBreak: 'break-all',
                  }}
                >
                  {dataDetail.emailCliente}
                </span>
              </div>
              <div className="d-flex">
                <span className="flex-shrink-0" style={{ width: '18rem' }}>
                  Produto/N° Contrato:
                </span>
                <span>{dataDetail.nomeProduto}</span>
              </div>
            </div>
            <div
              className="d-flex flex-column justify-content-around mx-3"
              style={{ height: '15rem' }}
            >
              <div
                className="d-flex flex-column align-items-start"
                style={{ fontSize: '1.25rem', fontWeight: '600' }}
              >
                <span>Conhecimento</span>
                <div className="d-flex">
                  <StarRating
                    name="react-star-rating"
                    numberOfStars={5}
                    rating={dataDetail.notaConhecimento}
                    starRatedColor="#ffc107"
                    starEmptyColor="#ced4da"
                    starHoverColor="#ffc107"
                    starDimension="1.8rem"
                  />
                  <span className="ms-2">{`(${dataDetail.notaConhecimento},0)`}</span>
                </div>
              </div>
              <div
                className="d-flex flex-column align-items-start"
                style={{ fontSize: '1.25rem', fontWeight: '600' }}
              >
                <span>Simpatia</span>
                <div className="d-flex">
                  <StarRating
                    name="react-star-rating"
                    numberOfStars={5}
                    rating={dataDetail.notaSimpatia}
                    starRatedColor="#ffc107"
                    starEmptyColor="#ced4da"
                    starHoverColor="#ffc107"
                    starDimension="1.8rem"
                  />
                  <span className="ms-2">{`(${dataDetail.notaSimpatia},0)`}</span>
                </div>
              </div>
              <div
                className="d-flex flex-column align-items-start"
                style={{ fontSize: '1.25rem', fontWeight: '600' }}
              >
                <span>Receptividade:</span>
                <div className="d-flex">
                  <StarRating
                    name="react-star-rating"
                    numberOfStars={5}
                    rating={dataDetail.notaReceptividade}
                    starRatedColor="#ffc107"
                    starEmptyColor="#ced4da"
                    starHoverColor="#ffc107"
                    starDimension="1.8rem"
                  />
                  <span className="ms-2">{`(${dataDetail.notaReceptividade},0)`}</span>
                </div>
              </div>
              <div
                className="d-flex flex-column align-items-start"
                style={{ fontSize: '1.25rem', fontWeight: '600' }}
              >
                <span>Avaliação Geral:</span>
                <div className="d-flex">
                  <StarRating
                    name="react-star-rating"
                    numberOfStars={5}
                    rating={dataDetail.notaGeral}
                    starRatedColor="#ffc107"
                    starEmptyColor="#ced4da"
                    starHoverColor="#ffc107"
                    starDimension="1.8rem"
                  />
                  <span className="ms-2">{`(${dataDetail.notaGeral},0)`}</span>
                </div>
              </div>
            </div>
          </div>
          <div
            className="mt-3 w-100 px-3"
            style={{ fontSize: '1.25rem', fontWeight: '600' }}
          >
            <span className="ms-4">Comentário</span>
            <Form.Control
              type="text"
              as="textarea"
              rows={6}
              disabled
              value={dataDetail.comentario}
              name="nomeGrupo"
              className="inputBox px-4 bg-white"
              style={{
                height: '13rem',
                resize: 'none',
              }}
            />
          </div>
        </div>
      </section>
      <section
        className="ms-3 d-flex flex-column"
        style={{
          width: '40%',
          borderRadius: '0.68rem',
          backgroundColor: '#FFF',
          fontSize: '1.25rem',
          boxShadow: '0px 4px 6px 3px rgba(0, 0, 0, 0.25)',
        }}
      >
        <div
          className="d-flex align-items-center ps-3"
          style={{
            borderTopLeftRadius: '0.68rem',
            borderTopRightRadius: '0.68rem',
            borderColor: 'transparent',
            backgroundColor: '#1A1A1A',
            fontSize: '1.25rem',
          }}
        >
          <Image
            style={{ height: '1.8rem', width: '2rem' }}
            src={ChatIcon}
            alt="Mensagens"
          />
          <span
            style={{
              color: '#fff',
              fontSize: '1.58rem',
              marginLeft: '0.6rem',
            }}
          >
            {`Chat - ${dataDetail.nomeCliente}`}
          </span>
        </div>
        <div
          className="d-flex px-1"
          style={{
            borderBottomLeftRadius: '0.68rem',
            borderBottomRightRadius: '0.68rem',
            flex: '1 1 0%',
          }}
        >
          <MessageContainer
            messages={
              historicoConversa.seqAtendimento === undefined
                ? undefined
                : historicoConversa
            }
            readOnly
          />
        </div>
      </section>
    </div>
  );
};

export default FeedbackDetail;
